﻿/*module: 
 * for global utility functions 
 */



async function PostFormAsync(e) {
    let formPostResponse = {
        ok: false,
        data: null,
    };
    const form = e.target;

    try {
        const formdata = new FormData(form);
        const response = await fetch(form.action,
            {
                method: form.method,
                body: formdata,
            });
        formPostResponse.ok = response.ok;
        if (!response.ok) {
            const err = await response.text();// retrieve text error
            formPostResponse.data = err;
        } else {
            const data = await response.json();
            formPostResponse.data = data;
        }
    }
    catch (error) {
        formPostResponse.ok = false;
        formPostResponse.data = error.message;
    }
    return formPostResponse;
}

// 1-Form async submission
function BindFormAsync(id, callback) {
    const form = document.getElementById(id);
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const resp = await PostFormAsync(e);
        if (!resp.ok) {//log some text..then submit error text
            console.log(resp.data.substr(0, 100) + '...');
        }
        callback(resp);
    });
}

// Fetch API to Get resources

async function GetJson(url) {
    var result = null;
    await fetch(url)
        .then(response => result = response.json())
        .catch(error => console.error(error));
    return result;
}
async function GetHtml(url) {
    var result = null;
    await fetch(url)
        .then(response => result = response.text())
        .catch(error => console.error(error));
    return result;
}
async function GetBlob(url) {
    var result = null;
    await fetch(url)
        .then(response => result = response.blob())
        .catch(error => console.error(error));
    return result;
}


export { BindFormAsync, GetJson, GetHtml, GetBlob };